// CRA embeds this application environment at build time; Datadog keeps its own RUM environment.
export const APPLICATION_ENVIRONMENT = process.env.REACT_APP_ENV ?? "unknown";
// Static previews use production React but still deliver local diagnostics through the loopback intake.
export const IS_LOCAL_DEVELOPMENT =
  APPLICATION_ENVIRONMENT === "local" &&
  (process.env.NODE_ENV === "development" || process.env.REACT_APP_LOCAL_STATIC === "true");
